import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
import Alexa from "./components/Alexa";
import PAE from "../components/PositionAwareElement";
import Online from "./components/Online";
import Updating from "./components/Updating";
import assign from "object-assign";
import BuyButton from "../../../components/BuyButton";


let Features = React.createClass({
    getInitialState() {
        return {
            triggers: {}
        };
    },
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Features";
        }
    },
    triggerElement(key, visChange, vPosChange, hPosChange, values) {
        if (!this.state[key] && vPosChange && values.topHalf) {
            this.setState(assign(this.state.triggers, {
                [key]: true
            }));
        }
    },
    mailingList() {
        this.app.navStore.showMailingListModal();
    },
    render() {
        return (
            <section className="eo-view features">
                <Hero>
                    <h1>Your router can't do this</h1>
                </Hero>
                <div className="eo-padded-wrapper">
                    <PAE className={["eo-60-sec eo-section grid-10 eo-info gradient-bg", (this.state.triggers.setup ? "triggered" : "")].join(" ")} onChange={this.triggerElement.bind(null, "setup")}>
                        <h2 className="grid-10 eo-60-sec-header standard">Your WiFi problems, gone</h2>

                        <div className="eo-text-group grid-10">
                            <p className="standard eo-60-sec-copy eo-info-copy">WiFi setup is the worst. You know it. We know it. With eero, simply download the app and plug one eero directly into your existing cable or DSL modem. The app takes it from there, prompting you to create a network name and password. Personality encouraged.</p>

                            <p className="standard eo-60-sec-copy eo-info-copy">Additional eeros just need power from a wall outlet. The app will help guide you where to place them to maximize their connection. You can add as many as you need to cover your home. Powered by advanced TrueMesh™ technology, they automatically connect to each other wirelessly. If you have Ethernet wiring, you can hardwire some or all of your eeros. eero will intelligently determine whether to send data over Ethernet or through the air.</p>
                        </div>
                    </PAE>
                    <section className="grid-10 everything-managed">
                        <div className="everything-managed-copy grid-6 grid-s-10 eo-info left">
                            <p className="icon eo-icon-phone standard section-icon everything-managed-icon"/>

                            <h2 className="standard">WiFi is no longer a black box</h2>

                            <p className="standard eo-info-copy">The eero app lets you manage your network from the palm of your hand, so you’ll know how many devices are connected and the Internet speed you’re getting from your ISP. The app also allows you to configure advanced settings like DHCP, NAT, DNS, UPnP, Port Forwarding, and flux capacitation.</p>
                        </div>
                        <div className="everything-managed-image grid-4 hide-s">
                            <img className="eo-img-fluid" src="/public/img/root/img-features-dashboard.png"/>
                        </div>
                    </section>
                    <section className="grid-10 family-profiles">
                        <div className="everything-managed-image grid-4 hide-s">
                            <img className="eo-img-fluid" src="/public/img/features/iphone-family-profiles.png"/>
                        </div>
                        <div className="everything-managed-copy grid-6 grid-s-10 eo-info left">
                            <p className="icon eo-icon-family standard section-icon everything-managed-icon" />

                            <h2 className="standard">More family time,<br />less screen time</h2>

                            <p className="standard eo-info-copy">Parental controls shouldn’t be one-size-fits-all: they should be tailored to each individual’s age and specific needs. With Family Profiles, manage your family’s screen time by creating profiles, setting schedules, managing devices, and pausing the internet for bedtime or important family moments like dinner. Now, the only thing standing between you and a great family game night is your family.</p>
                        </div>
                    </section>

                    <section className="grid-10 AlexaModule">
                        <PAE className={["AlexaModule-pae", (this.state.triggers.alexa ? "AlexaModule-isVisible" : "")].join(" ")} onChange={this.triggerElement.bind(null, "alexa")}>
                            <Alexa />
                        </PAE>
                    </section>


                    <section className="grid-10 fort-knox">
                        <div className="fort-knox-copy grid-6 grid-s-10 eo-info left">
                            <span className="fort-knox-icon icon section-icon eo-icon-shield-check"/>

                            <h2 className="standard">Security that's one step ahead</h2>

                            <p className="standard eo-info-copy">It may be out-of-sight, out-of-mind once you set it up, but think about the personal data transmitted over your network. eero is protected with state-of-the-art WPA2 encryption, and because it controls the hardware and the software for your entire network, it ensures that you’re always secure.</p>

                            <p className="standard eo-info-copy">Since traditional routers don’t push software updates to their customers, they are left vulnerable to cyber attacks. eero updates automatically so that you not only have the latest features, but the latest security.</p>

                            <a href="https://blog.eero.com/how-eero-keeps-your-network-safe-and-sound-6fcea89711e7#.ao3dlvfpe" target="_blank" className="extender-link eo-link">Learn how eero keeps your network safe and sound<span className="icon eo-icon-arrow-right"/></a>

                        </div>
                        <div className="fort-knox-image grid-4 hide-s">
                            <PAE className={["animated-bubble fort-knox-bubble", (this.state.triggers.knox ? "triggered" : "")].join(" ")} onChange={this.triggerElement.bind(null, "knox")}>
                                <div className="bubble-slide slide-1">
                                    <Updating/>
                                </div>
                            </PAE>
                        </div>
                        <img className="eero-shadow eo-img-fluid hide-s" src="/public/img/features/eero-with-shadow.png"/>
                    </section>
                    <section className="grid-10 self-fixing">
                        <div className="self-fixing-image grid-6 grid-m-5 grid-s-10 hide-s">
                            <PAE className={["animated-bubble self-fixing-bubble", (this.state.triggers.selfFixing ? "triggered" : "")].join(" ")}
                                 onChange={this.triggerElement.bind(null, "selfFixing")}>
                                <div className="bubble-slide slide-1">
                                   <Online/>
                                </div>
                            </PAE>
                        </div>
                        <div className="self-fixing-copy grid-4 grid-m-5 grid-s-10 eo-info left eo-text-group margin-large">
                            <span className="self-fixing-icon icon section-icon eo-icon-refresh"/>

                            <h2 className="standard">Never reset your router again</h2>

                            <p className="standard eo-info-copy">The mysterious silver bullet to many a WiFi woe is to unplug your router, then plug it back in. It’s like blowing on a Nintendo cartridge: a not-so-modern trick. eero regularly runs checkups so your network is always at its best. In the unlikely event that there’s an issue, your system can automatically reboot an individual eero (or multiple eeros) to fix the problem.</p>
                        </div>
                    </section>
                    <section className="grid-10 guest gradient-bg">
                        <div className="guest-copy grid-6 grid-s-10 eo-info left">
                            <p className="icon eo-icon-share section-icon guest-icon"/>

                            <h2 className="standard">Be our guest</h2>

                            <p className="standard eo-info-copy">Digging through the kitchen drawer and rattling off a 16-digit alphanumeric password from an old Post-it note is crazy. With eero, you invite your friends to join your network straight from the eero app — it can be as simple as sending a text. Plus, you can create an entirely separate guest network with the push of a button. Sure, they’re your friends, but every relationship needs boundaries.</p>
                        </div>
                        <div className="guest-image grid-4 hide-s">
                            <img className="eo-img-fluid" src="/public/img/features/iphone-guest-access.png"/>
                        </div>
                    </section>
                </div>

                <section className="grid-10 future-proof">
                    <div className="future-proof-copy grid-6 grid-s-10 eo-info left">
                        <p className="icon eo-icon-wifi-home section-icon future-proof-icon"/>

                        <h2>It’s all included. <br />Even the future.</h2>

                        <p className="standard eo-info-copy">eero comes with more memory and power than currently needed to zap WiFi to every corner of your home. That makes it possible to add features and improve performance over time just by pushing an update from the cloud.</p>
                    </div>
                </section>
                <section className="grid-10 eo-cta welcome hide-s">
                    <div className="eo-cta-content float-left">
                        <h2 className="eo-cta-header">WIFI ENVY.<br/>NOW A THING.</h2>
                        <BuyButton/>
                    </div>
                </section>
            </section>
        );
    }
});

export default Marty.createContainer(Features, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/features/Handler.js
 **/